import React from "react";
import PropTypes from "prop-types";
import { SortableHandle } from "react-sortable-hoc";

import PAC from "./PAC";
import ErrorList from "./ErrorList";

/**
 * -Location-
 * Location component
 **/
class Location extends React.Component {
	state = {};

	render() {
		return (
			<div
				className={ `location-wrapper ${ this.props.locations.length > 2 ? "has-drag-handles" : ""
					}` }
			>
				<div className="location-wrapper-inner">
					{ this.props.locations.length > 2 && <DragHandle /> }

					<PAC
						index={ this.props.index }
						location={ this.props.locations[this.props.index] }
						locations={ this.props.locations }
						setLocation={ this.props.setLocation }
						autoCompleteReady={ this.props.autoCompleteReady }
						reportError={ this.props.reportError }
						handleClearOptions={ this.props.handleClearOptions }
					/>

					{ this.props.locations.length > 2 && (
						<RemoveLocation
							removeLocation={ this.props.removeLocation }
							index={ this.props.index }
						/>
					) }
				</div>

				{ this.props.errors && <ErrorList errors={ this.props.errors } /> }
			</div>
		);
	}
}

const DragHandle = SortableHandle(() => (
	<span className="location-drag-handle">
		<svg className="field-icon">
			<use xlinkHref="#drag"></use>
		</svg>
	</span>
));

const RemoveLocation = ({ removeLocation, index }) => {
	return (
		<button
			className="remove-location"
			onClick={ () => removeLocation(index) }
			type="button"
		>
			<span className="assistive-text">Remove location</span>
			<svg className="field-icon">
				<use xlinkHref="#close"></use>
			</svg>
		</button>
	);
};

export default Location;

Location.propTypes = {
	locations: PropTypes.array.isRequired,
	setLocation: PropTypes.func.isRequired,
	removeLocation: PropTypes.func,
	reportError: PropTypes.func,
	index: PropTypes.number,
	errors: PropTypes.array,
	sortable: PropTypes.bool,
};

Location.defaultProps = {
	index: 0,
	sortable: false,
};



// WEBPACK FOOTER //
// ./src/components/Location.js